/** Sentinel value for missing / invalid driver scores (shared across metrics UI). */
export const INVALID_SCORE = -1;

export const isScoreValid = (score: number | undefined): boolean => {
    return score !== undefined && score !== INVALID_SCORE;
};
